import { format, addDays } from 'date-fns';

const mockMessage = {
  Event: 'message',
  Title: 'Use Fasttrack Integration inbox!',
  Message: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin sit amet lorem bibendum vulputate. Vivamus posuere sapien eget dolor laoreet, ut dictum velit tempor.<div><br></div>
    <h2>What more?</h2>
    <div>Phasellus luctus efficitur tortor. Fusce bibendum tortor a ipsum accumsan, et rutrum dui semper. Mauris rutrum elit ut risus molestie, <a href="https://www.google.com">at mollis ipsum eleifend</a>. Nullam et volutpat dolor. Curabitur ultrices vulputate risus eu rutrum. Integer interdum magna nec lorem aliquam scelerisque ac quis libero.</div>
    <div><br></div>
    <h4>Why inbox?</h4>
    <div>Reason 1</div>
    <div>Reason 2</div>
    <div>Reason 3</div>
  `,
  Data: {
    OverrideCommunicationStatus: '', TestKey: 'TestValue', TestBool: false, TestInt: 123,
  },
  CTAButtonLink: 'https://www.google.com',
  CTAButtonText: 'Primary button',
  ImageUrl: 'https://demo.ft-crm.com/img/demo-header.jpg',
  CTAButton2Link: 'https://www.google.com',
  CTAButton2Text: 'Secondary button',
  Expires: format(addDays(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
  DisplayType: 'push',
  PreviewText: 'Exclusive offer for you: Grab this nice weekend offer and claim your free spins!',
  FooterText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin sit amet lorem bibendum vulputate.',
};

export { mockMessage }; // eslint-disable-line
